import * as Rx from 'rxjs';
import * as _ from 'lodash';

import {IMessengerMessage, IProgressProvider, MessageType} from '../PA.Core.IF.Basic';
import {Messenger} from "./Messenger";
import {ExecutionSerializer} from "./ExecutionSerializer";
import {JSONUtils} from "./JSON";
import {Subscription} from "rxjs";

const bDebug = false

const ProgressProviderMessageType = "ProgressProviderState"
interface IMessageProgressProviderState extends IMessengerMessage {
    process_name: string
    process_running: boolean
    process_pcnt_complete: number
    process_progress_numerator: number
    process_progress_denominator: number
    process_completed: boolean
    process_failed: boolean
    process_exception: any
    progress_message_id: string
    progress_message_text: string

    bNotifyChange: boolean
    bNotifyComplete: boolean
}


export class ProgressProvider implements IProgressProvider
{
    process_name: string;
    process_running: boolean;
    process_pcnt_complete: number;
    process_progress_numerator: number;
    process_progress_denominator: number;
    process_completed: boolean;
    process_failed: boolean;
    process_exception: any;
    progress_message_id: string;
    progress_message_text: string;
    ProgressChanged: Rx.BehaviorSubject<IProgressProvider>;
    OnComplete: Rx.BehaviorSubject<IProgressProvider>;
    process_parent: any;

    _listenersPersistent: IProgressProvider[]
    _listenersTillComplete: IProgressProvider[]

    _msgrListenerToTransmitTo: {messenger: Messenger<IMessageProgressProviderState>, bRemoveOnComplete: boolean} []
    _msgrbNotifyComplete: boolean
    _qsTransmit: ExecutionSerializer

    _msgrInbox: Messenger<IMessageProgressProviderState>
    _msgrInboxSub: Subscription

    constructor(name?: string, parent?: any, channelGuid?: string)
    {
        this.setName(name);
        this.process_completed = true;
        this.process_running = false;
        this.process_pcnt_complete = 0;
        this.process_progress_numerator = 0;
        this.process_progress_denominator = 100;
        this.process_failed = false;
        this.process_exception = {};
        this.progress_message_id = "";
        this.progress_message_text = "";
        this.ProgressChanged = new Rx.BehaviorSubject<IProgressProvider>(null);
        this.OnComplete = new Rx.BehaviorSubject<IProgressProvider>(null);
        this.process_parent = parent;

        this._listenersPersistent = []
        this._listenersTillComplete = []
        this._msgrListenerToTransmitTo = []
        this._msgrbNotifyComplete = false
        this._qsTransmit = new ExecutionSerializer( this, this.TransmitStatusUpdate, [],500)
        this._msgrInbox = undefined
        this._msgrInboxSub = undefined
    }

    setName(name: string): void {
        this.process_name = name || this.process_name ||'Unnamed';

        _.forEach(this._listenersPersistent, (item: IProgressProvider) => {
            item.setName(name)})

        _.forEach(this._listenersTillComplete, (item: IProgressProvider) => {
            item.setName(name)})
    }

    start(name?: string): void {
        this.setName(name);
        this.process_running = true;
        this.process_completed = false;
        this.process_pcnt_complete = 0;
        this.process_failed = false;
        this.process_exception = {};
        this.progress_message_id = "";
        this.progress_message_text = "";
        this._notify();

        _.forEach(this._listenersPersistent, (item: IProgressProvider) => {
            item.start(name)
        })

        _.forEach(this._listenersTillComplete, (item: IProgressProvider) => {
            item.start(name)
        })

    }

    setProgressMessage(message_id: string, message_text: string): void {
        this.progress_message_id = message_id;
        this.progress_message_text = message_text;
        this._notify();

        _.forEach(this._listenersPersistent, (item: IProgressProvider) => {
            item.setProgressMessage(message_id, message_text)
        })

        _.forEach(this._listenersTillComplete, (item: IProgressProvider) => {
            item.setProgressMessage(message_id, message_text)
        })

    }

    setPercentComplete(pcnt_complete: number) {
        this.process_pcnt_complete = pcnt_complete;
        if (this.process_progress_denominator > 0) {
            this.process_progress_numerator = pcnt_complete * this.process_progress_denominator
        }
        this._notify();

        _.forEach(this._listenersPersistent, (item: IProgressProvider) => {
            item.setPercentComplete(pcnt_complete)
        })

        _.forEach(this._listenersTillComplete, (item: IProgressProvider) => {
            item.setPercentComplete(pcnt_complete)
        })
    }


    setProgressNumerator(numerator: number): void {

        this.process_progress_numerator = numerator;
        if (this.process_progress_denominator > 0) {
            this.process_pcnt_complete = numerator / this.process_progress_denominator
        }
        this._notify();

        _.forEach(this._listenersPersistent, (item: IProgressProvider) => {
            item.setProgressNumerator(numerator)
        })

        _.forEach(this._listenersTillComplete, (item: IProgressProvider) => {
            item.setProgressNumerator(numerator)
        })

    }

    setProgressDenominator(denominator: number): void {

        this.process_progress_denominator = denominator;
        if (this.process_progress_denominator > 0) {
            this.process_pcnt_complete = this.process_progress_numerator / this.process_progress_denominator
        }
        this._notify();

        _.forEach(this._listenersPersistent, (item: IProgressProvider) => {
            item.setProgressDenominator(denominator)
        })

        _.forEach(this._listenersTillComplete, (item: IProgressProvider) => {
            item.setProgressDenominator(denominator)
        })

    }

    finish(): void {
        this.process_pcnt_complete = 100;
        this.process_running = false;
        this.process_completed = true;
        this.process_failed = false;
        this._notify();
        this._notifyComplete();

        _.forEach(this._listenersPersistent, (item: IProgressProvider) => {
            item.finish()})

        _.forEach(this._listenersTillComplete, (item: IProgressProvider) => {
            item.finish()})

        this._listenersTillComplete = []

    }

    exception(anError: any): void {
        this.process_exception = anError;
        this.process_failed = true;
        this.process_running = false;
        this.process_completed = true;
        this._notify();
        this._notifyComplete();

        _.forEach(this._listenersPersistent, (item: IProgressProvider) => {
            item.exception(anError)})

        _.forEach(this._listenersTillComplete, (item: IProgressProvider) => {
            item.exception(anError)})

        this._listenersTillComplete = []
    }

    _notify(){
        var self = this;
        setTimeout(function(){
            self.ProgressChanged.next(self);
        },0);

        if(this._msgrListenerToTransmitTo.length)
            this._qsTransmit.Run({})
    }

    _notifyComplete(){
        var self = this;
        setTimeout(function(){
            self.OnComplete.next(self);
        },0);

        this._msgrbNotifyComplete = true
        if(this._msgrListenerToTransmitTo.length)
            this._qsTransmit.Run({bSkipDebounce: true})
    }

    addListener(aProgressProvider: IProgressProvider): void {
        if (_.isEmpty(aProgressProvider))
            return;

        this._listenersPersistent.push(aProgressProvider)
    }

    addListenerUtilComplete(aProgressProvider: IProgressProvider): void {
        if (_.isEmpty(aProgressProvider))
            return;

        this._listenersTillComplete.push(aProgressProvider)
    }

    removeListener(aProgressProvider: IProgressProvider): void {
        if (_.isEmpty(aProgressProvider)) {
            return;
        }

        _.remove(this._listenersTillComplete, (item: IProgressProvider) => {
            return aProgressProvider === item
        })

        _.remove(this._listenersPersistent, (item: IProgressProvider) => {
            return aProgressProvider === item
        })

    }


    removeAllListeners(): void {
        this._listenersPersistent = []
        this._listenersTillComplete = []
    }

    async addWSListener(channelId: string, bRemoveOnComplete?: boolean): Promise<void> {
        if(_.isEmpty(channelId))
            return
        // check if exists..
        for(let aMsgr of this._msgrListenerToTransmitTo){
            if(aMsgr.messenger.getChannel().channelId == channelId)
                return
        }

        let aMsgr = new Messenger<IMessageProgressProviderState>({InBoxEnabled: false, ChannelId: channelId})
        this._msgrListenerToTransmitTo.push({messenger: aMsgr, bRemoveOnComplete: !!bRemoveOnComplete})
    }

    removeWSlistener(pChannelId: string): void {
        let removedItems = _.remove(this._msgrListenerToTransmitTo, (a) => a.messenger.getChannel().channelId == pChannelId)
        _.forEach(removedItems, (a) => a.messenger.destroy())
    }

    removeAllWSListeners(): void {
        _.forEach(this._msgrListenerToTransmitTo, (aMsgr) => {
            aMsgr.messenger.destroy()
        })
        this._msgrListenerToTransmitTo = []
    }


    async listenOn(channelId?: string): Promise<void> {
        const self = this

        if(self._msgrInboxSub){
            self._msgrInboxSub.unsubscribe()
            self._msgrInboxSub = undefined
        }

        if(self._msgrInbox){
            self._msgrInbox.disableInBox()
            self._msgrInbox.destroy()
            self._msgrInbox = undefined
        }

        let msgrInbox = new Messenger<IMessageProgressProviderState>({InBoxEnabled: true, ChannelId: channelId})
        await msgrInbox.enableInBox()
        self._msgrInbox = msgrInbox
        self._msgrInboxSub = self._msgrInbox.OnInBoxMessageReceived.subscribe((evt) => {
            if(_.isEmpty(evt))
                return
            let msg = evt.message
            if(bDebug)
                console.log("Progress Provider received msg: ", msg)

            // Update Local State and fire Notify Events
            if(msg.messageType != ProgressProviderMessageType)
                return;

            self.process_name = msg.process_name
            self.process_running = msg.process_running
            self.process_pcnt_complete = msg.process_pcnt_complete
            self.process_progress_numerator = msg.process_progress_numerator
            self.process_progress_denominator = msg.process_progress_denominator
            self.process_completed = msg.process_completed
            self.process_failed = msg.process_failed
            self.process_exception = msg.process_exception
            self.progress_message_id = msg.progress_message_id
            self.progress_message_text = msg.progress_message_text

            if(msg.bNotifyChange)
                self._notify()

            if(msg.bNotifyComplete)
                self._notifyComplete()

        })
    }

    listenOff(): void {
        const self = this

        if(self._msgrInboxSub){
            self._msgrInboxSub.unsubscribe()
            self._msgrInboxSub = undefined
        }

        if(self._msgrInbox){
            self._msgrInbox.disableInBox()
            self._msgrInbox.destroy()
            self._msgrInbox = undefined
        }

    }

    get listenOnChannelId(): string {
        if(this._msgrInbox)
            return this._msgrInbox.getChannel().channelId

        return ""
    }


    async TransmitStatusUpdate(): Promise<void> {
        const self = this

        if(!self._msgrListenerToTransmitTo.length)
            return

        let msg: IMessageProgressProviderState = {
            messageType: ProgressProviderMessageType,
            process_name: self.process_name,
            process_running: self.process_running,
            process_pcnt_complete: self.process_pcnt_complete,
            process_progress_numerator: self.process_progress_numerator,
            process_progress_denominator: self.process_progress_denominator,
            process_completed: self.process_completed,
            process_failed: self.process_failed,
            process_exception: JSONUtils.parse(JSON.stringify(self.process_exception), undefined),
            progress_message_id: self.progress_message_id,
            progress_message_text: self.progress_message_text,

            bNotifyChange: true,
            bNotifyComplete: self._msgrbNotifyComplete
        }

        self._msgrbNotifyComplete = false

        for(let msgr of self._msgrListenerToTransmitTo){
            await msgr.messenger.postMessage(msg)
        }

        if(msg.bNotifyComplete){
            // Remove on Complete Listeners
            let removedItems = _.remove(this._msgrListenerToTransmitTo, (a) => a.bRemoveOnComplete)
            _.forEach(removedItems, (a) => a.messenger.destroy())
        }
    }
}
